module.exports = __webpack_public_path__ + "img/video-banner-background-mobile.160f9857.svg";